module.exports = __webpack_public_path__ + "img/logo-lyon-bg.bc48e1f0.png";